import React, { Suspense } from "react";
import { Canvas, useLoader } from "@react-three/fiber";
import { TextureLoader } from "three";
import { Cylinder } from "@react-three/drei";

const LogoMeshWithTexture: React.FC<{ logoUrl: string }> = ({ logoUrl }) => {
  const texture = useLoader(TextureLoader, logoUrl);

  return (
    <mesh rotation={[1.8, 0, 0]}>
      {/* Slightly tilted coin */}
      <cylinderGeometry args={[2.5, 2.5, 0.5, 64]} />
      <meshStandardMaterial map={texture} roughness={0.4} metalness={0.1} />
    </mesh>
  );
};

const LogoFallback: React.FC<{ color: string }> = ({ color }) => {
  return (
    <mesh rotation={[1.8, 0, 0]}>
      <cylinderGeometry args={[2.5, 2.5, 0.5, 64]} />
      <meshStandardMaterial color={color} roughness={0.3} metalness={0.3} />
    </mesh>
  );
};

interface TenantLogo3DProps {
  logoUrl?: string;
  primaryColor: string;
  size?: number; // CSS pixel size for the container
}

export const TenantLogo3D: React.FC<TenantLogo3DProps> = ({
  logoUrl,
  primaryColor,
  size = 20, // Default w-5 is 20px
}) => {
  return (
    <div style={{ width: size, height: size }}>
      <Canvas
        camera={{ position: [0, 0, 6], fov: 50 }}
        gl={{ alpha: true, antialias: true }}
      >
        <ambientLight intensity={1.5} />
        <pointLight position={[10, 10, 10]} intensity={2} />
        <pointLight position={[-10, -10, -5]} intensity={1} />

        {logoUrl ? (
          <Suspense fallback={<LogoFallback color={primaryColor} />}>
            <LogoMeshWithTexture logoUrl={logoUrl} />
          </Suspense>
        ) : (
          <LogoFallback color={primaryColor} />
        )}
      </Canvas>
    </div>
  );
};
